/*******************************************************************************************************************************************/
/* Prepare Slides
/*******************************************************************************************************************************************/
export function prepareSlides(sliderElement) {
    const slides = [...sliderElement.children]
    slides.forEach(slide => slide.classList.add('keen-slider__slide'))
}


/*******************************************************************************************************************************************/
/* Init Slider Wrapper
/*******************************************************************************************************************************************/
export function initSliderWrapper(wrapper, className = 'is-initialized') {
    wrapper.classList.add(className)
}


/*******************************************************************************************************************************************/
/* Arrows
/*******************************************************************************************************************************************/
export function initArrows(sliderInstance, prev, next) {
    prev.addEventListener('click', () => { sliderInstance.prev() })
    next.addEventListener('click', () => { sliderInstance.next() })
}

export function updateArrows(sliderInstance, prev, next, disabledClass = 'is-disabled') {
    const { relativeSlide, size, slidesPerView } = sliderInstance.details()

    relativeSlide === 0
    ? prev.classList.add(disabledClass)
    : prev.classList.remove(disabledClass)
    
    relativeSlide === size - slidesPerView
    ? next.classList.add(disabledClass)
    : next.classList.remove(disabledClass)
}


/*******************************************************************************************************************************************/
/* Dots
/*******************************************************************************************************************************************/
export function initDots(sliderInstance, sliderElement, dotsWrapper, dotClass = 'dot') {
    const slides = [...sliderElement.children]
    slides.forEach((slide, i) => {
        const dot = document.createElement('button')
        dot.type = 'button'
        dot.classList.add(dotClass)
        dotsWrapper.appendChild(dot)
        dot.addEventListener('click', () => { sliderInstance.moveToSlide(i) })
    })
}

export function updateDots(sliderInstance, dotsWrapper, activeClass = 'is-active') {
    const { relativeSlide } = sliderInstance.details()
    const dots = [...dotsWrapper.children]
    dots.forEach((dot, i) => {
        i === relativeSlide
        ? dot.classList.add(activeClass)
        : dot.classList.remove(activeClass)
    })
}